import {
  useFnsServiceCreateSurveyForAdminMutation,
  useFnsServiceUpdateSurveyForAdminMutation,
} from 'zma-react-sdk/fns-service'
import { useTenantStore } from '@/stores/tenantStore'
import { SurveyMutationInput } from '@/features/forms-and-surveys/types'

export function useCreateSurvey() {
  const { selectedTenantId } = useTenantStore()

  const [createSurvey, { loading, error }] =
    useFnsServiceCreateSurveyForAdminMutation({
      update: (cache, { data: _data }) => {
        // Invalidate and refetch the surveys list
        cache.evict({ fieldName: 'fnsServiceGetSurveysForAdmin' })
        cache.gc()
      },
    })

  const handleCreate = async (input: SurveyMutationInput) => {
    const result = await createSurvey({
      variables: { input },
      context: {
        headers: {
          'x-tenant-id': selectedTenantId,
        },
      },
    })
    return result
  }

  return {
    createSurvey: handleCreate,
    loading,
    error,
  }
}

export function useUpdateSurvey() {
  const { selectedTenantId } = useTenantStore()

  const [updateSurvey, { loading, error }] =
    useFnsServiceUpdateSurveyForAdminMutation({
      refetchQueries: ['FnsServiceGetSurveysForAdmin'],
    })

  const handleUpdate = async (id: string, input: SurveyMutationInput) => {
    const result = await updateSurvey({
      variables: { id, input },
      context: {
        headers: {
          'x-tenant-id': selectedTenantId,
        },
      },
    })
    return result
  }

  return {
    updateSurvey: handleUpdate,
    loading,
    error,
  }
}
